<div class="home-content">
    <!-- Layout -->
    <div class="header bg-gradient-danger container-fluid h-100vh d-flex align-items-center justify-content-center">
        <div class="card" style="max-width: 400px;">
            <div class="card-header text-center">
                <h2>No tienes permiso para acceder a esta ruta</h2>
            </div>
            <div class="card-body text-center d-flex flex-column align-items-center justify-content-center">
                <i class="fas fa-ban mb-3" style="font-size: 150px;"></i>
                <p class="m-0">
                    Es probable {{!isLoged?
                    "que tu sesión haya caducado"
                    :"que no tengas permiso de acceder a este módulo"}}.
                </p>
            </div>
            <div class="card-footer">
                <a mat-button *ngIf="!isLoged" [routerLink]="['/auth/login']"
                    class="secondary d-flex align-items-center justify-content-center w-100 mb-2">Iniciar
                    sesión</a>
                <a mat-button *ngIf="isLoged" [routerLink]="['/']"
                    class="secondary d-flex align-items-center justify-content-center w-100 mb-2">Volver al inicio</a>
                <button mat-button *ngIf="isLoged" (click)="goBack()"
                    class="primary d-flex align-items-center justify-content-center w-100 mb-2">Volver atrás</button>
            </div>
        </div>
    </div>
</div>